import React, { Component } from 'react';

const digits = [1,2,3,4,5,6,7,8,9];


class Stone extends Component {
  render() {
    return (<ellipse cx="50" cy={this.props.cy} rx="50" ry="25"
	    onClick={()=>this.props.onClick(this.props)} />)
  }
}


class Row extends Component {
  constructor(props) {
    super(props);
    this.state = { stones: digits.map(x => this.moveStoneDown(x)),
		   digit:0 };
    this.moveStones = this.moveStones.bind(this)
  }


  moveStones(stoneProps) {
    // each stone calls this method when clicked
    // set state for all stones in row
    if (stoneProps.up) {
      // move stone and bigger down
      this.setState({ stones: digits.map( x => {return((x>=stoneProps.digit) ? this.moveStoneDown(x) : this.moveStoneUp(x))}),
		      digit: (stoneProps.digit-1) });
    } else {
      // move stone and smaller up
      this.setState({ stones: digits.map( x => { return((x<=stoneProps.digit) ? this.moveStoneUp(x) : this.moveStoneDown(x)) }),
		      digit:stoneProps.digit });
    }
  }

  moveStoneUp(digit) {
    return( {digit:digit, cy:(digit*50), up:true} );
  }
  
  moveStoneDown(digit) {
    return( {digit:digit, cy:(digit*50+525), up:false} );
  }
  
  render() {
    return(<div>
	   <div className= 'decimalDigit'>{this.state.digit}</div>
	   <svg id= "abacusSVG"
	        xmlns= 'http://www.w3.org/2000/svg'
                baseProfile= "tiny"
                viewBox= "0 0 100 1000" >

	       <line x1="50" x2="50" y1="20" y2="1000" />

	   {this.state.stones.map( (stone) =>
				       <Stone digit={stone.digit} cy={stone.cy} up={stone.up}
				              onClick={this.moveStones} /> )}
             </svg> 
	   </div>
	  )
  }
}

const Rows = digits.map( x => <Row key={x} /> );
const Abacus = <div id="rowsDIV"> {Rows} </div>;

export default Abacus;



// WEBPACK FOOTER //
// ./src/abacus.js